<template>
    <product-overview id="WL_overview" title="Group Whole Life Insurance" :ctaLink="`/${$route.params.id}/whole-life`">
        <template v-slot:video>
            <a-video />
        </template>
        <p>Group Whole Life pays a benefit directly to your beneficiary and provides a level of security above
        coverage you may already have from your employer or term insurance you’ve
        purchased on your own.</p>
        <template v-slot:key-features>
            <key-feature-bullet v-if="product['WLUnderwritingBasis.GMC'] === 'Guaranteed Issue'">
                Guaranteed issue benefit amounts available to employees – <strong>no medical exams</strong>
            </key-feature-bullet>
            <key-feature-bullet>
                Death benefit amounts that won’t decrease and premiums that won’t increase 
            </key-feature-bullet>
            <key-feature-bullet>
                <strong>Access to cash value</strong>
            </key-feature-bullet>
            <key-feature-bullet>
                <strong>Portable coverage</strong> — if you switch jobs or retire you can take your coverage with you, after 30 days of continuous coverage
            </key-feature-bullet>
        </template>
    </product-overview>
</template>
<script>
import { mapGetters } from 'vuex'
import  { WholeLifeVideo as AVideo } from '@/components/videos'
import ProductOverview from '@/components/product-overviews/product-overview'
import KeyFeatureBullet from '@/components/key-feature-bullet'

export default {
    components: {
        AVideo,
        ProductOverview,
        KeyFeatureBullet
    },
    data(){
        return {
        }
    },
    computed: {
        ...mapGetters({
            product: 'getWholeLife',
            proposalId: 'getProposalId'
        })    
    }
}
</script>
